"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = filterOptions;

var _actionTypes = require("../constants/actionTypes");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initState = {};

function filterOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.INIT_COLUMN_FILTER_OPTIONS:
      _lodash["default"].set(state, [action.filterType, action.columnType, 'fetching'], false);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'displayOptions'], action.options);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'originOptions'], action.options);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'filterParams'], null);

      return _objectSpread({}, state);

    case _actionTypes.SET_COLUMN_FILTER_OPTIONS:
      _lodash["default"].set(state, [action.filterType, action.columnType, 'fetching'], false);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'displayOptions'], action.options);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'originOptions'], action.options);

      return _objectSpread({}, state);

    case _actionTypes.SEARCH_COLUMN_FILTER_OPTIONS:
      var originOptions = _lodash["default"].get(state, [action.filterType, action.columnType, 'originOptions'], []);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'displayOptions'], _lodash["default"].filter(originOptions, function (option) {
        return option.name.toUpperCase().indexOf(action.value.toUpperCase()) !== -1;
      }));

      return _objectSpread({}, state);

    case _actionTypes.FETCH_COLUMN_FILTER_OPTIONS:
      _lodash["default"].set(state, [action.filterType, action.columnType, 'fetching'], true);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'filterParams'], action.filterParams);

      return _objectSpread({}, state);

    case _actionTypes.FETCH_COLUMN_FILTER_OPTIONS_ERROR:
      _lodash["default"].set(state, [action.filterType, action.columnType, 'fetching'], false);

      _lodash["default"].set(state, [action.filterType, action.columnType, 'filterParams'], null);

      return _objectSpread({}, state);

    default:
      return state;
  }
}